import {
  FileType,
  GlobalFunctions,
  GlobalConstantsTexte,
} from 'globales-projekt-angular';
import { Guid } from 'guid-typescript';
import * as JSZip from 'jszip';
import { RubrikBmel } from 'src/app/data/ws/rubrik-bmel';
import { ConstantsBMELCodes } from '../../immutable/constants-bmel-codes';

export class LogikCsv {
  rubrikBmel: RubrikBmel[] = [];
  
  betriebsNummerPseudonymisierung = new Map<string, string>(); 

  constructor();
  constructor(logikCsv: LogikCsv);
  constructor(logikCsv?: LogikCsv) {
    if (logikCsv != undefined) {
      this.rubrikBmel = logikCsv.rubrikBmel;
    }
  }

  async getCsvZipContent(filesToUpload: FileList): Promise<string[][]> {
    let sleepFlag: number = 0;
    let csvInhalt: string[][] = [];

    let erlaubteExtensions: FileType[] = [];
    erlaubteExtensions.push(FileType.ZIP_EXT);

    for (let i = 0; i < filesToUpload.length; i++) {
      let file: File = filesToUpload.item(i);

      if (GlobalFunctions.checkFileExtension(file, erlaubteExtensions)) {
        const jsZip: JSZip = new JSZip();

        jsZip.loadAsync(file).then((zip: JSZip) => {
          let zipFileName: string;
          let dateiEndungFalsch: string = '';
          let i = 0;

          zip.forEach(
            (relPath: string, file: { dir: boolean; name: string }) => {
              if (
                file.dir == false &&
                !relPath.toLowerCase().endsWith(FileType.CSV_EXT)
              ) {
                dateiEndungFalsch += '\n' + file.name.replace(zipFileName, '');
              } else if (i == 0) zipFileName = file.name;
              i++;
            }
          );

          if (dateiEndungFalsch.length != 0) {
            sleepFlag = -9999;
            alert(
              GlobalFunctions.replacePlatzhalter(
                GlobalConstantsTexte.ZIP_KEINE_GUELTIGER_DATEITYP_IN_ZIP,
                dateiEndungFalsch,
                file.name,
                FileType.CSV_SHORT
              )
            );
            return;
          }

          Object.keys(zip.files).forEach((filename) => {
            sleepFlag++;
            if (zip.files[filename].dir == false) {
              zip.files[filename].async('string').then((fileData: string) => {
                let verarbeitet: string[][] =
                  this.verarbeiteCSVInhalt(fileData);

                if (verarbeitet == null) {
                  sleepFlag = -9999;
                  alert(
                    GlobalFunctions.replacePlatzhalter(
                      GlobalConstantsTexte.ZIP_UNGÜLTIGER_DATEIINHALT_IN_ZIP,
                      zip.files[filename].name,
                      zipFileName
                    )
                  );
                  return;
                } else csvInhalt = csvInhalt.concat(verarbeitet);

                sleepFlag--;
              });
            }
          });
        });
      } else {
        sleepFlag++;
        const reader: FileReader = new FileReader();
        reader.onload = () => {
          let verarbeitet: string[][] = this.verarbeiteCSVInhalt(
            reader.result as string
          );

          if (verarbeitet == null) {
            sleepFlag = -9999;
            alert(
              GlobalFunctions.replacePlatzhalter(
                GlobalConstantsTexte.DATEI_UNGÜLTIGER_DATEIINHALT_IN_DATEI,
                file.name
              )
            );
            return null;
          } else csvInhalt = csvInhalt.concat(verarbeitet);

          sleepFlag--;
        };

        reader.readAsText(file);
      }
    }
    await GlobalFunctions.sleep(250);
    {
      let sleebExitCounter: number = 0;

      do {
        if (sleepFlag == 0) break;
        else if (sleepFlag < 0) return null;

        await GlobalFunctions.sleep(250);

        if (sleebExitCounter++ == 10) return null;
      } while (true);
    }

    return GlobalFunctions.shuffle(csvInhalt);
  }

  verarbeiteCSVInhalt(fileData: string): string[][] {
    console.log(fileData);
    let splitted: string[] = fileData.split('\r\n');
    let gesaeubertDateien: string[][] = [];
    let aktuelleDatei: string[] = [];
    
    for (let entry of splitted) {
     
      let splittedLine: string[] = entry.split(';');

      if (splittedLine.length != 0) {
        let code: number = +splittedLine[0];
        
        for (let entry2 of this.rubrikBmel) {
          if (entry2.codeBmel == code) {
            if (code == ConstantsBMELCodes.CODE_BETRIEBSNUMMER) {
               console.log(  splittedLine[1]);
              splittedLine = this.cleareRow(splittedLine, 1);
              splittedLine[1] = this.setGetBetriebsnummerPseudonymisiert(
                splittedLine[1]
              ); 

              entry = splittedLine.join(';');
            } else if (code == ConstantsBMELCodes.CODE_BUCHSTELLE) {
              if (aktuelleDatei.length != 0) {
                gesaeubertDateien.push(aktuelleDatei);
                aktuelleDatei = [];
              }
              splittedLine = this.cleareRow(splittedLine, entry2.spaltenNr - 1);
              entry = splittedLine.join(';');
            } else {
              splittedLine = this.cleareRow(splittedLine, entry2.spaltenNr - 1);
              entry = splittedLine.join(';');
            }

            aktuelleDatei.push(entry);
            continue;
          }
        }
      }
    }

    if (aktuelleDatei.length == 0) return null;

    gesaeubertDateien.push(aktuelleDatei);

    return gesaeubertDateien;
  }

  cleareRow(row: string[], ignoreColumn: number): string[] {
    for (let i = 1; i < row.length; i++) {
      if (i == ignoreColumn) continue;

      row[i] = '';
    }

    return row;
  }

  setGetBetriebsnummerPseudonymisiert(betriebsnummer: string): string {
    console.log(betriebsnummer);
    let guid: string = Guid.create().toString(); 
    this.betriebsNummerPseudonymisierung.set(guid, betriebsnummer);
 

    
    
    
    return guid;
  }

  getBetriebsnummerDepseudonymisiert(guid: string): string {
    return this.betriebsNummerPseudonymisierung.get(guid);
  }
}
